(() => {
  if (window.VistoIslands) return

  const registry = new Map()
  const mounted = new WeakMap()

  const getIslandNodes = (root = document) => {
    const nodes = []

    if (root instanceof HTMLElement && root.matches('[data-visto-react-island]')) {
      nodes.push(root)
    }

    if ('querySelectorAll' in root) {
      nodes.push(...root.querySelectorAll('[data-visto-react-island]'))
    }

    return nodes
  }

  const parseProps = (node) => {
    const source = node.querySelector('[data-visto-island-props]')
    const raw = source?.textContent || node.dataset.vistoProps || '{}'

    try {
      return JSON.parse(raw)
    } catch (error) {
      console.warn('[VistoIslands] Invalid island props.', error)
      return {}
    }
  }

  const mountNode = async (node) => {
    if (mounted.has(node)) return mounted.get(node)

    const islandType = node.dataset.vistoReactIsland || 'default'
    const factory = registry.get(islandType)

    if (!factory) {
      node.dataset.vistoIslandState = 'unregistered'
      return null
    }

    node.dataset.vistoIslandState = 'loading'

    const vendor = await window.VistoVendor.loadReact()
    const props = parseProps(node)
    const component = await factory({
      node,
      props,
      vendor,
      React: vendor.React,
      ReactDOM: vendor.ReactDOM,
    })

    if (!component) {
      node.dataset.vistoIslandState = 'empty'
      return null
    }

    const root = vendor.ReactDOM.createRoot(node)
    root.render(component)

    const instance = {
      type: islandType,
      root,
      destroy() {
        root.unmount()
        mounted.delete(node)
        delete node.dataset.vistoIslandState
      },
    }

    mounted.set(node, instance)
    node.dataset.vistoIslandState = 'mounted'
    return instance
  }

  const destroyNode = (node) => {
    mounted.get(node)?.destroy()
  }

  const init = (root = document) => {
    if (!window.VistoVendor) return Promise.resolve([])

    const nodes = getIslandNodes(root)
    if (!nodes.length) return Promise.resolve([])

    return Promise.all(nodes.map((node) => mountNode(node).catch((error) => {
      node.dataset.vistoIslandState = 'error'
      console.error('[VistoIslands] Failed to mount island.', error)
      return null
    })))
  }

  const destroy = (root = document) => {
    getIslandNodes(root).forEach(destroyNode)
  }

  const register = (type, factory) => {
    if (!type || typeof factory !== 'function') return

    registry.set(type, factory)
    init()
  }

  window.VistoIslands = {
    register,
    init,
    destroy,
    mountNode,
    destroyNode,
    get registeredTypes() {
      return Array.from(registry.keys())
    },
  }

  document.addEventListener('DOMContentLoaded', () => init())
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target instanceof HTMLElement) init(event.target)
  })
  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target instanceof HTMLElement) destroy(event.target)
  })
})()
